
export const getEOLObligationApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/eol_obligations${queryString ? `?${queryString}` : ""}`;
};

export const deleteEOLAttachment = (slug) => {
    return `lease/eol_obligations/${slug}/attachments`
}

export const getEOLObligationDetailApi = (params, slug) => {
    return `/lease/${params?.leaseSlug}/eol_obligatio/ns`;
}
export const addEolObligationApi = (params, payload) => {
    return `/lease/${params?.leaseSlug}/eol_obligations`;
}
export const editEolObligationApi = (params) => {
    return `/lease/${params?.leaseSlug}/eol_obligations/${params?.slug}`;
}

export const eolObligationfileExportApi = (params) => {
    return `/lease/${params?.leaseSlug}/eol_obligations/export/`;
};

export const deleteEOLObligationApi = (params, payload) => {
    return `/lease/${params?.leaseSlug}/eol_obligations`;
}

export const eolObligationfileUploadPostApi = (supplement_slug) => {
    return `/get-pre-signed-url/lease/${supplement_slug}`;
};

export const eolObligationAttachmentMetaData=(attachments_slug)=>{
    return `update-attachment-metadata/lease/${attachments_slug}`
}
